import { Action } from '@ngrx/store';

export const RESET_BUILDER = 'RESET_BUILDER';

export class ResetBuilderAction implements Action {
  readonly type = RESET_BUILDER;
  constructor(public payload?: any) {}
}

export type OrderBuilderActions = ResetBuilderAction;
